import { Icon, Stack, useTheme } from "@fluentui/react";
import React, { useEffect } from "react";
import { getAepPayloadContentType } from "../../../externalApi/AepApi";
import { acceptPrivacyNotice } from "../../../externalApi/DashboardHostApi";
import { addVisibilityEventListeners, getIsWindowVisible, getLastShowReason, removeVisibilityEventListeners, requestHide } from "../../../externalApi/WindowApi";
import { getResources } from "../../../getResources";
import { formatString } from "../../../utils/stringUtilities";
import { Button } from "../../generic/Button/Button";
import { getWideDefaultButtonStyle } from "../../generic/Button/Button.styles";
import { Grid } from "../../generic/Grid/Grid";
import { Text } from "../../generic/Text/Text";
import { getLocationNetworkCTAPageStyle, getServiceIconStyle } from "./LocationNetworkCTAPage.styles";
import { ServiceTextContainer } from "./ServiceTextContainer/ServiceTextContainer";
import { logPageEvent, logPageHidden, logPageShown } from "../Telemetry/PageTelemetry";
const LocationNetworkCTAPage = (props) => {
    const theme = useTheme();
    const handleWindowShown = async () => {
        const [aepPayloadContentType, lastShowReason] = await Promise.all([
            getAepPayloadContentType(),
            getLastShowReason(),
        ]);
        logPageShown("loc-net-cta", aepPayloadContentType, lastShowReason);
    };
    const handleWindowHidden = () => {
        logPageHidden("loc-net-cta");
    };
    useEffect(() => {
        logPageEvent("loc-net-cta");
        addVisibilityEventListeners(handleWindowShown, handleWindowHidden);
        // If the Window is visible fire the visibility event since we will have missed the first on on cold launch.
        getIsWindowVisible().then((visible) => {
            if (visible) {
                handleWindowShown();
            }
        }, (reason) => {
            // If windowAPI is unavailable do nothing
        });
        return () => {
            removeVisibilityEventListeners(handleWindowShown, handleWindowHidden);
        };
    }, []);
    return (React.createElement("div", { onClick: (e) => { var _a; return (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e); }, style: { height: "100%" } },
        React.createElement(Stack, { id: "loc-net-cta", horizontalAlign: "center", verticalAlign: "center", styles: getLocationNetworkCTAPageStyle() },
            React.createElement(Text, { variant: "xxLarge", marginBottom: "12px" }, getResources().LocationNetworkCTAPage_Greeting),
            React.createElement(Text, { variant: "medium", marginBottom: "28px" }, formatString(getResources().LocationNetworkCTAPage_Subtext)),
            React.createElement(ServiceTextContainer, { marginBottom: 8 },
                React.createElement(Icon, { id: "poi-icon", iconName: "POI", styles: getServiceIconStyle(theme) }),
                React.createElement(Text, { variant: "medium", textAlign: "left" }, getResources().LocationNetworkCTAPage_LocationAccessPermission)),
            React.createElement(ServiceTextContainer, { marginBottom: "28px" },
                React.createElement(Icon, { id: "network-icon", iconName: "NetworkTower", styles: getServiceIconStyle(theme) }),
                React.createElement(Text, { variant: "medium", textAlign: "left" }, getResources().LocationNetworkCTAPage_WLANAccessPermission)),
            React.createElement(Grid, { tokens: { childrenGap: 15, columns: 2 } },
                React.createElement(Button, { id: "hide-button", onClick: () => requestHide(), styles: getWideDefaultButtonStyle() }, getResources().LocationNetworkCTAPage_DenyButtonText),
                React.createElement(Button, { id: "accept-privacy-button", onClick: () => acceptPrivacyNotice(), styles: getWideDefaultButtonStyle() }, getResources().LocationNetworkCTAPage_AcceptButtonText)))));
};
export default LocationNetworkCTAPage;
